import React from "react";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

import "./about.css";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>4+ Years Working</small>
            </article>
            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Clients</h5>
              <small>50+ </small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>25+ Completed</small>
            </article>
          </div>
          <p>
            Passionate developper with four years developing experience, able to
            build responsive web application from scratch. I am extremely
            motivated with a strong eye for innovative design and strong
            interest in projects that require both conceptual and analytical
            thinking. Skilled at delivering codes that are testable, re-usable
            and efficient at using current best practices in web development and
            WCAG guidelines.
          </p>
          <a href="#contact" className="btn btn-primary">
            Hire Me
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
